module.exports = __webpack_public_path__ + "img/gem-dark-active.d8f5a7de.png";